







































































































import { Component, Prop } from 'vue-property-decorator';
import { CSSStyleOptions } from '../common-types';
import { SwScrollView } from '../sw-scroll-view';
import { SwExtendedVue } from '../sw-extended-vue';

@Component({
  components: {
    SwScrollView,
  },
})
export default class SwDropdown extends SwExtendedVue {
  @Prop({ type: Boolean, default: true })
  withArrow: boolean;

  @Prop({ type: Number, default: 500 })
  maxWidth: number;

  @Prop({ type: Number, default: 250 })
  maxHeight: number;

  @Prop({ type: [Number] })
  width: number | undefined;

  cssPrefix: string = 'sw-dropdown';

  get innerStyle(): CSSStyleOptions {
    return {
      maxHeight: this.maxHeight ? `${this.maxHeight}px` : undefined,
      maxWidth: this.maxWidth ? `${this.maxWidth}px` : undefined,
      width: this.width !== undefined ? `${this.width}px` : undefined,
    };
  }
}
